import { type ApiError, PASSWORD_CHANGE_REQUIRED } from '@bqcrm/shared';

/** Zdarzenie okna: serwer odrzucił żądanie, bo konto ma wymaganą zmianę hasła. */
export const PASSWORD_CHANGE_EVENT = 'bqcrm:zmiana-hasla';

/** Błąd API z polskim komunikatem i szczegółami walidacji. */
export class HttpError extends Error {
  constructor(
    public readonly status: number,
    message: string,
    public readonly details: string[] = [],
    public readonly data: unknown = undefined,
  ) {
    super(message);
  }
}

export async function api<T>(path: string, init: { method?: string; body?: unknown } = {}): Promise<T> {
  const res = await fetch(`/api${path}`, {
    method: init.method ?? 'GET',
    credentials: 'same-origin',
    headers: init.body !== undefined ? { 'content-type': 'application/json' } : undefined,
    body: init.body !== undefined ? JSON.stringify(init.body) : undefined,
  });
  if (res.status === 204) return undefined as T;
  const data = (await res.json().catch(() => null)) as unknown;
  if (!res.ok) {
    const err = (data ?? {}) as Partial<ApiError>;
    // wymagana zmiana hasła (ustawiona w trakcie pracy) — aplikacja przeładowuje profil i pokazuje ekran zmiany hasła
    if (res.status === 403 && (err.data as { code?: string } | undefined)?.code === PASSWORD_CHANGE_REQUIRED) window.dispatchEvent(new Event(PASSWORD_CHANGE_EVENT));
    throw new HttpError(res.status, err.message ?? `Błąd ${res.status}`, err.details ?? [], err.data);
  }
  return data as T;
}

/** Wysyłka formularza z plikami (multipart) — te same komunikaty błędów co `api`. */
export async function apiForm<T>(path: string, form: FormData, method = 'POST'): Promise<T> {
  const res = await fetch(`/api${path}`, { method, body: form, credentials: 'same-origin' });
  if (res.status === 204) return undefined as T;
  const data = (await res.json().catch(() => null)) as unknown;
  if (!res.ok) {
    const err = (data ?? {}) as Partial<ApiError>;
    throw new HttpError(res.status, err.message ?? `Błąd ${res.status}`, err.details ?? [], err.data);
  }
  return data as T;
}

export function errorText(err: unknown): string {
  if (err instanceof HttpError) return [err.message, ...err.details].join('\n');
  if (err instanceof Error) return err.message === 'Failed to fetch' ? 'Brak połączenia z serwerem' : err.message;
  return 'Nieznany błąd';
}
